export function diferences_between_arrays(a, b) {
  /**
   * Returns the elements not present in both arrays.
   * - Returns unique elements, duplicated values will be returned only once.
   * - Does NOT preserve order.
   * 
   * EXAMPLE:
   *   diferences_between_arrays([1,2,3,4,5], [3,4,5,5,6,6,7,8])
   *   → [1, 2, 6, 7, 8]
   */
  const union = new Set([...a, ...b]);
  const set_a = new Set(a);
  const set_b = new Set(b);
  return [...union].filter(x => set_a.has(x) != set_b.has(x));
}

const cache = {};
export function cached_method(name, fun) {
  /**
   * Cache function calling.
   * NOTE: Arguments must be convertable to string
   *
   * USAGE:
   *   cached_method(method) → cacheable_call
   *
   * EXAMPLE:
   *   const my_function = cached_method(function(x, y) { return x + y })
   *   my_function(1, 2) // Will call the method
   *   my_function(1, 2) // Will return cached value
   */
  return function(/* ... */) {
    const args = arguments;  
    const key = name + '狐' + [].slice.call(args).join('狐');
    if (cache[key]) {
      return cache[key];
    } else {
      cache[key] = fun.apply(this, args);
      return cache[key];
    }
  };
}

export function async_cached_method(name, fun) {
  /**
   * Same as cached_method, but for async function calls
   */
  return async function(/* ... */) {
    const args = arguments;  
    const key = name + '狐' + [].slice.call(args).join('狐');
    if (cache[key]) {
      return cache[key];
    } else {
      cache[key] = await fun.apply(this, args);
      return cache[key];
    }
  };
}

export function is_dictionary(value) {
  /**
   * Returns true when value is a dictionary
   * Examples:
   * * {} → true
   * * {a: 2} → true
   * * [1] → false
   * * (new Date()) → false
   * * 'hola' → false
   * Source:
   * https://stackoverflow.com/questions/38304401/javascript-check-if-dictionary
   * MOD: Added undefined and null checks due to TypeError
   */
  return (
    (value !== undefined)
      && (value !== null)
      && (value.constructor === Object)
  );
}
